import React from "react";

const Content = () => {
    return (
        <>
            <main id="body-content">
                <section className="wide-tb-100 pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Buttons Styles</h3>
                                <a href="#" className="btn-theme bg-secondary mr-2 icon-only"><i className="icofont-envelope"></i></a>
                                <a href="#" className="mr-2 mb-3 btn-theme bg-primary"><span>Blue</span></a>
                                <a href="#" className="mr-2 mb-3 btn-theme bg-secondary"><span>Orange</span></a>

                                <a href="#" className="mr-2 mb-3 btn-theme bg-secondary">Icon Default <i className="icofont-rounded-right"></i></a>
                                <a href="#" className="mr-2 mb-3 btn-theme bg-primary icon-left"><i className="icofont-rounded-right"></i> Icon Left</a>
                                <a href="#" className="mr-2 mb-3 btn-theme bg-sky-blue light">Sky Blue</a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100 pb-0">
                    <section className="wide-tb-80 bg-fixed bg-img-7 pos-rel">
                        <div className="bg-overlay white opacity-40"></div>
                        <div className="container">
                            <div className="row align-items-center text-center">
                                <div className="col-sm-12">
                                    <a href="#" className="mr-2 mb-3 btn-theme bordered bg-sky-blue">Border</a>
                                    <a href="#" className="mr-2 mb-3 btn-theme bordered bg-secondary">Border Orange</a>
                                    <a href="#" className="mr-2 mb-3 btn-theme bordered bg-primary">Border Blue</a>
                                    <a href="#" className="btn btn-theme bg-white bordered">Get In Touch <i className="icofont-rounded-right"></i></a>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
                <section className="wide-tb-100 pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Accordian Style</h3>
                            </div>
                            <div className="col-md-4 col-sm-6">
                                <div className="theme-collapse">
                                    <div className="toggle">
                                        <i className="icofont-rounded-down"></i> We Are Passionate
            </div>
                                    <div className="collapse">
                                        <div className="content">
                                            Nunc non mollis nulla. Sed tconsectetur
                                           elit id mi consectetur bibendum. Aenean
                                           sollicitudin. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam,
              </div>
                                    </div>
                                    <div className="toggle">
                                        <i className="icofont-rounded-down"></i> Professional Team Members
            </div>
                                    <div className="collapse">
                                        <div className="content">
                                            Nunc non mollis nulla. Sed tconsectetur
                                           elit id mi consectetur bibendum. Aenean
                                           sollicitudin. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam,
              </div>
                                    </div>
                                    <div className="toggle">
                                        <i className="icofont-rounded-down"></i> We Love To Support
            </div>
                                    <div className="collapse">
                                        <div className="content">
                                            Nunc non mollis nulla. Sed tconsectetur
                                           elit id mi consectetur bibendum. Aenean
                                           sollicitudin. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam,
              </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-6">
                                <div className="theme-collapse arrow-right-border">
                                    <div className="toggle">
                                        <i className="icofont-rounded-down"></i> We Are Passionate
            </div>
                                    <div className="collapse">
                                        <div className="content">
                                            Nunc non mollis nulla. Sed tconsectetur
                                           elit id mi consectetur bibendum. Aenean
                                           sollicitudin. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam,
              </div>
                                    </div>
                                    <div className="toggle">
                                        <i className="icofont-rounded-down"></i> Professional Team Members
            </div>
                                    <div className="collapse">
                                        <div className="content">
                                            Nunc non mollis nulla. Sed tconsectetur
                                           elit id mi consectetur bibendum. Aenean
                                           sollicitudin. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam,
              </div>
                                    </div>
                                    <div className="toggle">
                                        <i className="icofont-rounded-down"></i> We Love To Support
            </div>
                                    <div className="collapse">
                                        <div className="content">
                                            Nunc non mollis nulla. Sed tconsectetur
                                           elit id mi consectetur bibendum. Aenean
                                           sollicitudin. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam,
              </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-6">
                                <div className="theme-collapse capsules">
                                    <div className="toggle">
                                        <i className="icofont-rounded-down"></i> We Are Passionate
            </div>
                                    <div className="collapse">
                                        <div className="content">
                                            Nunc non mollis nulla. Sed tconsectetur
                                           elit id mi consectetur bibendum. Aenean
                                           sollicitudin. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam,
              </div>
                                    </div>
                                    <div className="toggle">
                                        <i className="icofont-rounded-down"></i> Professional Team Members
            </div>
                                    <div className="collapse">
                                        <div className="content">
                                            Nunc non mollis nulla. Sed tconsectetur
                                           elit id mi consectetur bibendum. Aenean
                                           sollicitudin. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam,
              </div>
                                    </div>
                                    <div className="toggle">
                                        <i className="icofont-rounded-down"></i> We Love To Support
            </div>
                                    <div className="collapse">
                                        <div className="content">
                                            Nunc non mollis nulla. Sed tconsectetur
                                           elit id mi consectetur bibendum. Aenean
                                           sollicitudin. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam,
              </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100 pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Jumbotron</h3>
                            </div>
                        </div>
                    </div>
                    <section className="wide-tb-100 bg-fixed clients-bg pos-rel">
                        <div className="bg-overlay blue opacity-80"></div>
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="text-center txt-white">
                                        <h1 className="display-4">Hello, world!</h1>
                                        <p className="lead">This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.</p>
                                        <hr className="my-4" />
                                        <p>It uses utility classNamees for typography and spacing to space content out within the larger container.</p>
                                        <a className="btn btn-theme bg-white bordered" href="#" role="button">Learn more</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
                <section className="wide-tb-100 pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Message Boxes</h3>
                            </div>
                            <div className="col-sm-4">
                                <div className="alert alert-primary" role="alert">
                                    A simple primary alert
          <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="alert alert-secondary" role="alert">
                                    A simple secondary alert
          <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="alert alert-success" role="alert">
                                    A simple success alert
          <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="alert alert-danger" role="alert">
                                    A simple danger alert
          <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="alert alert-warning" role="alert">
                                    A simple warning alert
          <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="alert alert-info" role="alert">
                                    A simple info alert
          <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="alert alert-light" role="alert">
                                    A simple light alert
          <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="alert alert-dark" role="alert">
                                    A simple dark alert
          <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="alert alert-theme" role="alert">
                                    A simple dark alert
          <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100 pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Tabbing Style</h3>
                            </div>
                            <div className="col-sm-6">
                                <ul className="nav nav-pills theme-tabbing mb-3" id="pills-tab" role="tablist">
                                    <li className="nav-item">
                                        <a className="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">Our History</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">Our Mission</a>
                                    </li>
                                </ul>
                                <div className="tab-content theme-tabbing" id="pills-tabContent">
                                    <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                        <h4 className="h4-xs txt-blue">Our History</h4>
                                        <p>Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits. </p>
                                        <p>Dramatically visualize customer directed convergence without revolutionary ROI.</p>
                                    </div>
                                    <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                                        <h4 className="h4-xs txt-blue">Our Mission</h4>
                                        <p>Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits. </p>
                                        <p>Dramatically visualize customer directed convergence without revolutionary ROI.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <ul className="nav nav-pills theme-tabbing mb-3" id="pills-tab2" role="tablist">
                                    <li className="nav-item">
                                        <a className="nav-link active" data-toggle="pill" href="#pills-home-first" role="tab" aria-controls="pills-home-first" aria-selected="true"><i className="icofont-user-alt-3"></i>  Tab One</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" data-toggle="pill" href="#pills-profile-second" role="tab" aria-controls="pills-profile-second" aria-selected="false"><i className="icofont-umbrella-alt"></i> Tab Two</a>
                                    </li>
                                </ul>
                                <div className="tab-content theme-tabbing" id="pills-tabContent2">
                                    <div className="tab-pane fade show active" id="pills-home-first" role="tabpanel" aria-labelledby="pills-home-tab">
                                        <h4 className="h4-xs txt-blue">Tab One</h4>
                                        <p>Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits. </p>
                                        <p>Dramatically visualize customer directed convergence without revolutionary ROI.</p>
                                    </div>
                                    <div className="tab-pane fade" id="pills-profile-second" role="tabpanel" aria-labelledby="pills-profile-tab">
                                        <h4 className="h4-xs txt-blue">Tab Two</h4>
                                        <p>Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits. </p>
                                        <p>Dramatically visualize customer directed convergence without revolutionary ROI.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100 pb-0 mb-spacer-md">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Statistics Counter</h3>
                            </div>
                        </div>
                        <div className="row d-flex align-items-center">
                            <div className="col col-12 col-lg-3 col-sm-6">
                                <div className="counter-style-1 light-bg">
                                    <p className="mb-1"><i className="icofont-google-map"></i></p>
                                    <span className="counter">15</span>
                                    <div>
                                        Our Locations
            </div>
                                </div>
                            </div>
                            <div className="col col-12 col-lg-3 col-sm-6">
                                <div className="counter-style-1 light-bg">
                                    <p className="mb-1"><i className="icofont-globe"></i></p>
                                    <span className="counter">110</span>
                                    <span>+</span>
                                    <div>
                                        Clients Worldwide
            </div>
                                </div>
                            </div>
                            <div className="w-100 d-none d-sm-block d-lg-none spacer-60"></div>
                            <div className="col col-12 col-lg-3 col-sm-6">
                                <div className="counter-style-1 light-bg">
                                    <p className="mb-1"><i className="icofont-vehicle-delivery-van"></i></p>
                                    <span className="counter">240</span>
                                    <span>+</span>
                                    <div>
                                        Owned Vehicles
            </div>
                                </div>
                            </div>
                            <div className="col col-12 col-lg-3 col-sm-6">
                                <div className="counter-style-1 light-bg">
                                    <p className="mb-1"><i className="icofont-umbrella-alt"></i></p>
                                    <span className="counter">2340</span>
                                    <div>
                                        Tonnes Transported
            </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100 bg-scroll counter-bg pos-rel mt-5">
                    <div className="bg-overlay blue opacity-50"></div>
                    <div className="container">
                        <div className="row">
                            <div className="col counter-style-1 col-6 col-lg-3 col-sm-6">
                                <p><i className="icofont-google-map"></i></p>
                                <span className="counter">15</span>
                                <div>
                                    Our Locations
          </div>
                            </div>
                            <div className="col counter-style-1 col-6 col-lg-3 col-sm-6">
                                <p><i className="icofont-globe"></i></p>
                                <span className="counter">110</span>
                                <span>+</span>
                                <div>
                                    Clients Worldwide
          </div>
                            </div>
                            <div className="w-100 d-none d-sm-block d-lg-none spacer-60"></div>
                            <div className="col counter-style-1 col-6 col-lg-3 col-sm-6">
                                <p><i className="icofont-vehicle-delivery-van"></i></p>
                                <span className="counter">240</span>
                                <span>+</span>
                                <div>
                                    Owned Vehicles
          </div>
                            </div>
                            <div className="col counter-style-1 col-6 col-lg-3 col-sm-6">
                                <p><i className="icofont-umbrella-alt"></i></p>
                                <span className="counter">2340</span>
                                <div>
                                    Tonnes Transported
          </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100 pb-0 mb-spacer-md">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-6">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Circular Progress Bar</h3>
                                <div className="row piecharts" id="pie-charts">
                                    <div className="col-lg-4 col-md-4">
                                        <span className="chart" data-percent="90">
                                            <span className="percent"></span>
                                        </span>
                                        <div className="skill-name">Dreamweaver</div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <span className="chart" data-percent="90">
                                            <span className="percent"></span>
                                        </span>
                                        <div className="skill-name">Wordpress</div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <span className="chart" data-percent="95">
                                            <span className="percent"></span>
                                        </span>
                                        <div className="skill-name">HTML5/CSS</div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <span className="chart" data-percent="66">
                                            <span className="percent"></span>
                                        </span>
                                        <div className="skill-name">Jquery</div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <span className="chart" data-percent="85">
                                            <span className="percent"></span>
                                        </span>
                                        <div className="skill-name">Photoshop</div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <span className="chart" data-percent="86">
                                            <span className="percent"></span>
                                        </span>
                                        <div className="skill-name">Illustrator</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-12">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Skills Bar</h3>
                                <div className="skillbar-wrap">
                                    <div className="clearfix">
                                        Road Transport
              </div>
                                    <div className="skillbar" data-percent="95%">
                                        <div className="skillbar-percent">95%</div>
                                        <div className="skillbar-bar"></div>
                                    </div>
                                </div>
                                <div className="skillbar-wrap">
                                    <div className="clearfix">
                                        Logistics
              </div>
                                    <div className="skillbar" data-percent="75%">
                                        <div className="skillbar-percent">75%</div>
                                        <div className="skillbar-bar"></div>
                                    </div>
                                </div>
                                <div className="skillbar-wrap">
                                    <div className="clearfix">
                                        Truck Rental
              </div>
                                    <div className="skillbar" data-percent="50%">
                                        <div className="skillbar-percent">50%</div>
                                        <div className="skillbar-bar"></div>
                                    </div>
                                </div>
                                <div className="skillbar-wrap">
                                    <div className="clearfix">
                                        Courier
              </div>
                                    <div className="skillbar" data-percent="95%">
                                        <div className="skillbar-percent">95%</div>
                                        <div className="skillbar-bar"></div>
                                    </div>
                                </div>
                                <div className="skillbar-wrap">
                                    <div className="clearfix">
                                        Air Transport
              </div>
                                    <div className="skillbar" data-percent="60%">
                                        <div className="skillbar-percent">60%</div>
                                        <div className="skillbar-bar"></div>
                                    </div>
                                </div>
                                <div className="skillbar-wrap">
                                    <div className="clearfix">
                                        Support
              </div>
                                    <div className="skillbar" data-percent="95%">
                                        <div className="skillbar-percent">95%</div>
                                        <div className="skillbar-bar"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100 pb-0 mb-spacer-md">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Icon Boxes</h3>
                            </div>
                            <div className="col-12 col-lg-4">
                                <div className="icon-box-2">
                                    <div className="media">
                                        <div className="service-icon">
                                            <i className="icofont-id"></i>
                                        </div>
                                        <div className="service-inner-content media-body">
                                            <h4 className="h4-md">Trusted Franchise</h4>
                                            <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4">
                                <div className="icon-box-2">
                                    <div className="media">
                                        <div className="service-icon">
                                            <i className="icofont-live-support"></i>
                                        </div>
                                        <div className="service-inner-content media-body">
                                            <h4 className="h4-md">Customer Support</h4>
                                            <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4">
                                <div className="icon-box-2">
                                    <div className="media">
                                        <div className="service-icon">
                                            <i className="icofont-history"></i>
                                        </div>
                                        <div className="service-inner-content media-body">
                                            <h4 className="h4-md">Reliability & Punctuality</h4>
                                            <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-100 spacer-60 d-none d-md-none d-lg-block d-sm-none"></div>
                            <div className="col-12 col-sm-6">
                                <div className="icon-box-3 mb-5 bg-sky-blue">
                                    <div className="media">
                                        <div className="service-icon mr-5 bg-primary">
                                            <i className="icofont-box"></i>
                                        </div>
                                        <div className="service-inner-content media-body">
                                            <h4 className="h4-md">Packaging and Storage</h4>
                                            <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae. Praesent pellentesque diam vitae nibh aliquam faucibus.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6">
                                <div className="icon-box-3 mb-5 bg-sky-blue">
                                    <div className="media">
                                        <div className="service-icon mr-5">
                                            <i className="icofont-shield"></i>
                                        </div>
                                        <div className="service-inner-content media-body">
                                            <h4 className="h4-md">Safety & Quality</h4>
                                            <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae. Praesent pellentesque diam vitae nibh aliquam faucibus.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="bg-light-gray">
                    <div className="container-fluid p-0">
                        <div className="row align-items-center no-gutters">
                            <div className="col-lg-4 text-center">
                                <div className="px-5 wide-tb-100">
                                    <div className="service-icon mx-auto mb-5 icon-box-5">
                                        <i className="icofont-glass"></i>
                                    </div>
                                    <h4 className="h4-md fw-7 txt-blue">SAFE & SECURE</h4>
                                    Nunc non mollis nulla. Sed tconsectetur elit id mi consectetur bibendum.
          </div>
                            </div>
                            <div className="col-lg-4 text-center bg-fixed clients-bg pos-rel txt-white">
                                <div className="bg-overlay black opacity-40"></div>
                                <div className="px-5 wide-tb-100" style={{
                                    position: "relative", zIndex: "999"
                                }}>
                                    <div className="service-icon mx-auto mb-5 icon-box-5">
                                        <i className="icofont-delivery-time"></i>
                                    </div>
                                    <h4 className="h4-md fw-7">FAST DELIVERY</h4>
                                    Nunc non mollis nulla.Sed tconsectetur elit id mi consectetur bibendum.
          </div>
                            </div>
                            <div className="col-lg-4 text-center">
                                <div className="px-5 wide-tb-100">
                                    <div className="service-icon mx-auto mb-5 icon-box-5">
                                        <i className="icofont-live-support"></i>
                                    </div>
                                    <h4 className="h4-md fw-7 txt-blue">24/7 Support</h4>
                                    Nunc non mollis nulla. Sed tconsectetur elit id mi consectetur bibendum.
          </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100 pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Call To Action Buttons</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-80 bg-scroll bg-img-6 pos-rel callout-style-1">
                    <div className="bg-overlay blue opacity-60"></div>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-4 col-md-12 mb-0">
                                <h4 className="h4-xl">Interested in working with Logzee?</h4>
                            </div>
                            <div className="col">
                                <div className="center-text">
                                    We don’t just manage suppliers, we micro-manage them. We have a consultative, personalized approach
          </div>
                            </div>
                            <div className="col-sm-auto">
                                <a href="#" className="btn btn-theme bg-white bordered">Get In Touch <i className="icofont-rounded-right"></i></a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-80 bg-secondary pos-rel callout-style-1">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-4 col-md-12 mb-0">
                                <h4 className="h4-xl">Interested in working with Logzee?</h4>
                            </div>
                            <div className="col">
                                <div className="center-text">
                                    We don’t just manage suppliers, we micro-manage them. We have a consultative, personalized approach
          </div>
                            </div>
                            <div className="col-sm-auto">
                                <a href="#" className="btn btn-theme bg-white bordered">Get In Touch <i className="icofont-rounded-right"></i></a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-80 bg-fixed bg-img-7 pos-rel callout-style-1">
                    <div className="bg-overlay blue opacity-60"></div>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-4 col-md-12 mb-0">
                                <h4 className="h4-xl">Interested in working with Logzee?</h4>
                            </div>
                            <div className="col">
                                <div className="center-text">
                                    We don’t just manage suppliers, we micro-manage them. We have a consultative, personalized approach
          </div>
                            </div>
                            <div className="col-sm-auto">
                                <a href="#" className="btn btn-theme bg-white bordered">Get In Touch <i className="icofont-rounded-right"></i></a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100 pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Testimonials And Popup </h3>
                            </div>
                            <div className="col-lg-10 offset-lg-1 mb-5">
                                <div className="bg-scroll client-testimonials-bg pos-rel rounded">
                                    <div className="bg-overlay blue opacity-80"></div>
                                    <div className="owl-carousel owl-theme" id="client-testimonials-bg">
                                        <div className="item">
                                            <div className="client-testimonial">
                                                <div className="client-testimonial-icon rounded-circle bg-primary mx-auto mb-4">
                                                    <img src="images/team_1.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="item">
                                            <div className="client-testimonial">
                                                <div className="client-testimonial-icon rounded-circle bg-primary mx-auto mb-4">
                                                    <img src="images/team_2.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="item">
                                            <div className="client-testimonial">
                                                <div className="client-testimonial-icon rounded-circle bg-primary mx-auto mb-4">
                                                    <img src="images/team_3.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 my-5">
                                <div className="owl-carousel owl-theme" id="home-client-testimonials">
                                    <div className="item">
                                        <div className="client-testimonial bg-wave">
                                            <div className="media">
                                                <div className="client-testimonial-icon rounded-circle bg-primary">
                                                    <img src="images/team_1.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="client-testimonial bg-wave">
                                            <div className="media">
                                                <div className="client-testimonial-icon rounded-circle bg-primary">
                                                    <img src="images/team_2.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="client-testimonial bg-wave">
                                            <div className="media">
                                                <div className="client-testimonial-icon rounded-circle bg-primary">
                                                    <img src="images/team_3.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 offset-lg-2 col-md-10 offset-md-1 pb-5">
                                <div className="bg-fixed pos-rel video-popup" style={{ margin: "0 !important" }}>
                                    <div className="bg-overlay black opacity-50"></div>
                                    <div className="zindex-fixed pos-rel">
                                        <a href="#" className="play-video"><i className="icofont-play icofont-4x"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div className="video-box">
                                <div className="close-video">
                                    <i className="fa fa-times"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
};
export default Content;
